import { parseAbsolute, parseDate } from '@internationalized/date';

export const parseCalendarDate = (value: string) =>
  value !== '' ? parseDate(value) : null;

export const parseCalendarDateWithTimezone = (
  value: string,
  timezone: string
) => (value !== '' ? parseAbsolute(value, timezone) : null);
